// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XR76m","footerTop":"footer_footerTop__7acBm","footerBottom":"footer_footerBottom__t3d6p","customUnderline":"footer_customUnderline__KTDY2"};